import React, { ReactElement } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { UserPermission } from '../../enum/userPermissions';
import useSessionUser from '../../hooks/useSessionUser';
import { hasPermission } from '../../services/users/identity/user.service';

function ExaminerRoute({ ...rest }: RouteProps): ReactElement {
  const { user } = useSessionUser();
  return user && hasPermission(user, UserPermission.ExaminerDashboardRead) ? (
    <Route {...rest} />
  ) : (
    <Redirect to={'/'} />
  );
}

export default ExaminerRoute;
